<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title" class="mr-2"></page-header-title>
        <help-text :tooltip="$t('certificates.title_tooltip')" />

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(certificate.id)" v-if="certificate.id && $can('certificate-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-combobox
                  name="certificate.participant_id"
                  v-model="certificate.participant_id"
                  :items="participants"
                  item-text="full_name"
                  item-value="id"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('certificates.participant_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('certificate.participant_id')"
                  :clearable="view == 'student' ? false : true"
                  :readonly="view == 'student' ? true : false"
                  :disabled="Boolean(predata._participant_id)"
                  :search-input.sync="searchStudent"
                ></v-combobox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="certificate.coursetypegroup_id"
                  v-model="certificate.ctg_id"
                  :items="coursetypegroups"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypegroups.stitle')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('certificate.coursetypegroup_id')"
                  @change="courseTypeGroupChange()"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-show="computedCourseTypeRequired">
                <v-autocomplete
                  name="certificate.coursetype_id"
                  v-model="selectedCourseTypes"
                  :items="coursetypes"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypes.title')"
                  autocomplete="new-password"
                  v-validate="computedCourseTypeRequired ? 'required' : ''"
                  :class="computedCourseTypeRequired ? 'required-field' : ''"
                  :error-messages="errors.collect('certificate.coursetype_id')"
                  clearable
                  multiple
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-show="computedTitleRequired">
                <!--<v-autocomplete
                                    name="certificate.title"
                                    v-model="additionalTitles"
                                    :items="additionalTitles"
                                    :label="$t('certificates.title')"
                                    class="cert-title"
                                    autocomplete="new-password"
                                    v-validate="computedTitleRequired ? 'required' : ''"
                                    :class="computedTitleRequired ? 'required-field' : ''"
                                    :error-messages="errors.collect('certificate.title')"
                                    :readonly="true"
                                    multiple
                                >
                                    <template v-slot:append class="mt-0">
                                        <action-button type="new" :icon_only="true" small @click="openAddTitle" class="add-title-btn" />
                                    </template>

                                    <template v-slot:selection="data">   
                                        {{ data.item }}
                                        <v-btn icon small color="red" @click="removeAdditionalTitle(data.index)">
                                            <v-icon>fas fa-times</v-icon>
                                        </v-btn>
                                    </template>
                                </v-autocomplete>-->
                <!--<v-text-field
                                    name="certificate.title"
                                    v-model="certificate.title"
                                    class="required-field"
                                    v-validate="'required|max:50'"
                                    :label="$t('certificates.title')"
                                    :error-messages="errors.collect('certificate.title')"
                                    autocomplete="new-password"
                                ></v-text-field>-->
                <v-text-field
                  name="certificate.title"
                  v-model="newTitle"
                  :label="$t('certificates.title')"
                  :class="computedTitleRequired ? 'required-field' : ''"
                  hide-details=""
                  autocomplete="new-password"
                >
                  <template v-slot:append class="mt-0">
                    <action-button type="new" :icon_only="true" small @click="saveAddTitle" class="add-title-btn" />
                  </template>
                </v-text-field>
                <v-simple-table class="tbl-titles" dense>
                  <tbody>
                    <tr v-for="(title, index) in additionalTitles" :key="index">
                      <td>{{ title }}</td>
                      <td class="text-end">
                        <v-btn icon small color="red" @click="removeAdditionalTitle(index)">
                          <v-icon>fas fa-times</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <input
                  type="hidden"
                  name="certificate.title"
                  v-model="additionalTitles"
                  :class="computedTitleRequired ? 'required-field' : ''"
                  :error-messages="errors.collect('certificate.title')"
                />
                <div class="v-text-field__details mt-1">
                  <div class="v-messages theme--light error--text" role="alert">
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message">{{ errors.first("certificate.title") }}</div>
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="issued_date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="certificate.issued_date"
                      v-model="computedIssuedDate"
                      :label="$t('certificates.issued_date')"
                      v-validate="'validDate'"
                      :error-messages="errors.collect('certificate.issued_date')"
                      append-icon="event"
                      @click:append="issued_date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker color="primary" v-model="certificate.issued_date" first-day-of-week="1" :locale="this.$locale_bcp47()">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="issued_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="certificate.issued_by"
                  v-model="certificate.issued_by"
                  :label="$t('certificates.issued_by')"
                  :error-messages="errors.collect('certificate.issued_by')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="certificate.issued_by_vat"
                  v-model="certificate.issued_by_vat"
                  :label="$t('certificates.issued_by_vat')"
                  v-validate="'numeric'"
                  :error-messages="errors.collect('certificate.issued_by_vat')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="valid_until_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="certificate.valid_until"
                      v-model="computedValidUntil"
                      :label="$t('courses.valid_until')"
                      v-validate="'validDate'"
                      :error-messages="errors.collect('certificate.valid_until')"
                      append-icon="event"
                      @click:append="valid_until_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="certificate.valid_until"
                    first-day-of-week="1"
                    :locale="this.$locale_bcp47()"
                    :min="certificate.issued_date"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="valid_until_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="certificate.course_held_by"
                  v-model="certificate.course_held_by"
                  :label="$t('certificates.course_held_by')"
                  :error-messages="errors.collect('certificate.course_held_by')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="certificate.company_name"
                  v-model="certificate.company_name"
                  v-validate="'max:50'"
                  :label="$t('certificates.company_name')"
                  :error-messages="errors.collect('certificate.company_name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-autocomplete
                                    name="certificate.class_id"
                                    v-model="certificate.class_id"
                                    :items="classes"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('certificates.class_id')"
                                    autocomplete="new-password"
                                    :error-messages="errors.collect('certificate.class_id')"
                                    clearable
                                ></v-autocomplete>
                            </v-flex>-->
              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                    name="certificate.course_name"
                                    v-model="certificate.course_name"
                                    :label="$t('certificates.course_name')"
                                    :error-messages="errors.collect('certificate.course_name')"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>-->
              <v-flex xs12 sm6>
                <v-textarea
                  name="certificate.description"
                  v-model="certificate.description"
                  :label="$t('certificates.note')"
                  :error-messages="errors.collect('certificate.description')"
                  rows="2"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-file-input
                  v-model="files"
                  color="primary"
                  counter
                  multiple
                  :placeholder="$t('certificates.select_files')"
                  prepend-icon="attach_file"
                  outlined
                  :show-size="1000"
                  accept=".jpg,.jpeg,.png,.pdf"
                  v-validate="'size:5120'"
                  name="file"
                  :error-messages="errors.collect('file')"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip color="primary" dark label small>
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-flex>
              <v-flex xs12>
                <v-card
                  @drop.prevent="documentOnDrop($event)"
                  @dragover.prevent="document_dragover = true"
                  @dragenter.prevent="document_dragover = true"
                  @dragleave.prevent="document_dragover = false"
                  :class="{ 'grey lighten-2': document_dragover }"
                >
                  <v-card-text>
                    <v-row class="d-flex flex-column" dense align="center" justify="center">
                      <v-icon :class="[document_dragover ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                      <p>{{ $t("global.drop_files_here") }}</p>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 class="text-center">
                <p class="subtitle font-weight-bold mb-0 mt-3 red--text">{{ $t("certificates.file_upload_note") }}</p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4" v-if="certificate.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("certificates.moduletemplates") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex md12>
                <v-simple-table>
                  <tbody>
                    <template v-for="(moduletemplate, idx) in moduletemplates">
                      <tr :key="'mt_' + moduletemplate.id">
                        <td>
                          <v-btn text small icon @click="clpsExpndModules(idx)">
                            <v-icon>{{ !mtCollapsed[idx] ? "expand_less" : "expand_more" }}</v-icon>
                          </v-btn>
                          {{ moduletemplate.name }}
                        </td>
                      </tr>
                      <tr v-if="moduletemplate.moduleoptions.length > 0 && !mtCollapsed[idx]" :key="'mo_' + moduletemplate.id">
                        <td>
                          <v-simple-table>
                            <tbody>
                              <tr v-for="moduleoption in moduletemplate.moduleoptions" :key="moduleoption.id" class="white-tr">
                                <td>{{ moduleoption.name }}</td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2" v-if="certificate.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("certificates.documents") }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <!--<action-button
                            type="new"
                            small
                            :icon_only="true"
                            @click="openUpload"
                        />-->
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="dc_headers"
                  :items="subpanel_documents"
                  :items-per-page="subpanel_documents.length"
                  :options.sync="dc_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="dc_total"
                  :loading="dc_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.size="{ item }">
                    {{ $formatBytes(item.size) }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <action-button type="edit" @click="openEditFile(item)" :icon_only="true" />
                    <action-button type="download" @click="downloadFile(item.id, item.original_filename)" :icon_only="true" />
                    <action-button type="delete" @click="deleteFile(item.id)" :icon_only="true" />
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>

    <v-dialog v-model="showAddTitleModal" persistent max-width="480px">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-form ref="form">
            <v-container grid-list-md>
              <v-card>
                <v-app-bar flat dense color="secondary">
                  <v-toolbar-title class="subheading">{{ $t("certificates.add_title") }}</v-toolbar-title>
                </v-app-bar>
                <v-card-text class="pa-4">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        ref="new_title"
                        name="certificate.title"
                        v-model="newTitle"
                        :label="$t('certificates.title')"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />

                  <action-button type="cancel" @click="closeAddTitle" />
                  <action-button type="save" @click="saveAddTitle" />
                </v-card-actions>
              </v-card>
            </v-container>
          </v-form>
        </v-container>
      </div>
    </v-dialog>

    <v-dialog v-model="showEditFileModal" persistent max-width="480px">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-form ref="form">
            <v-container grid-list-md>
              <v-card>
                <!--<v-app-bar flat dense color="secondary">
                                    <v-toolbar-title class="subheading">{{ $t('certificates.upload_files') }}</v-toolbar-title>
                                </v-app-bar>-->
                <v-card-text class="pa-4">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        name="certificate.filename"
                        v-model="computedFileName"
                        :label="$t('certificates.filename')"
                        :suffix="'.' + computedFileExtension"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="certificate.title"
                        v-model="selectedFile.title"
                        :label="$t('certificates.title')"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />

                  <action-button type="cancel" @click="closeEditFile" />
                  <action-button type="save" @click="updateFile" />
                </v-card-actions>
              </v-card>
            </v-container>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import actionButton from "../../../mixins/components/actionButton.vue"
export default {
  components: { actionButton },
  name: "CertificateForm",

  props: ["id"],

  data() {
    return {
      page_title: "",

      predata: {},
      certificate: {},
      course: {},
      drivingtest: {},
      moduletemplates: [],
      mtCollapsed: [],

      coursetypegroups: [],
      coursetypes: [],
      ctg_coursetype_mandatory: false,
      selectedCourseTypes: [],

      participants: [],
      searchStudent: null,

      classes: [],
      courses: [],

      subpanel_documents: [],

      files: [],

      view: "",
      from_module: "",
      from_id: "",

      issued_date_menu: false,
      valid_until_menu: false,

      additionalTitles: [],
      showAddTitleModal: false,
      newTitle: "",

      dc_ids: [],
      dc_total: 0,
      dc_show_loading: false,
      dc_refresh: false,
      dc_pagination: {
        page: this.$getLocalStorage("__certificateDocumentListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      showEditFileModal: false,
      selectedFile: {},
      document_dragover: false,

      dictionary: {
        attributes: {
          "certificate.title": this.$t("certificates.title"),
          "certificate.company_name": this.$t("certificates.company_name"),
          "certificate.issued_date": this.$t("certificates.issued_date"),
          "certificate.issued_by": this.$t("certificates.issued_by"),
          "certificate.issued_by_vat": this.$t("certificates.issued_by_vat"),
          "certificate.course_name": this.$t("certificates.course_name"),
          "certificate.course_held_by": this.$t("certificates.course_held_by"),
          "certificate.drivingtest_id": this.$t("certificates.drivingtest_id"),
          "certificate.attendee_id": this.$t("certificates.attendee_id"),
          "certificate.coursetype_id": this.$t("coursetypes.title"),
          "certificate.participant_id": this.$t("certificates.participant_id")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.certificate, this.predata, this.save, this.isFormValid)
    })
  },

  watch: {
    dc_refresh: {
      handler() {
        if (this.dc_refresh && this.id) {
          this.dc_list()
        }
      }
    },
    dc_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__certificateDocumentListPage", newVal.page)
          }

          this.dc_refresh = true
        }
      }
    },
    searchStudent: {
      handler: _.debounce(function (value) {
        if (!value) return

        if (value.length >= 3) {
          this.getStudents("fullname", value)
        } else {
          this.participants = []
        }
      }, 300)
    }
  },

  computed: {
    dc_headers: {
      get() {
        return [
          { text: this.$t("certificates.filename"), value: "original_filename" },
          { text: this.$t("certificates.title"), value: "title" },
          { text: this.$t("certificates.size"), value: "size" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end" }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedIssuedDate: {
      get() {
        return this.$dateFormatGetter(this.certificate.issued_date)
      },
      set(val) {
        this.$set(this.certificate, "issued_date", this.$dateFormatSetter(val))
      }
    },
    computedValidUntil: {
      get() {
        return this.$dateFormatGetter(this.certificate.valid_until)
      },
      set(val) {
        this.$set(this.certificate, "valid_until", this.$dateFormatSetter(val))
      }
    },
    computedFileName: {
      get() {
        return this.selectedFile && this.selectedFile.id ? this.selectedFile.original_filename.replace(/\.[^/.]+$/, "") : ""
      },
      set(val) {
        let filename = val + "." + this.computedFileExtension
        this.$set(this.selectedFile, "original_filename", filename)
      }
    },
    computedFileExtension() {
      return this.selectedFile && this.selectedFile.id ? this.selectedFile.original_filename.split(".").pop() : ""
    },
    computedSelectedCourseTypeGroupName() {
      let value = null

      if (this.certificate.ctg_id) {
        let ctg = this.coursetypegroups.find((i) => i.id == this.certificate.ctg_id)
        if (ctg) {
          value = "(" + ctg.category + ") " + ctg.name
        }
      }

      return value
    },
    computedCourseTypeRequired() {
      let bool = false

      if (this.certificate.ctg_id) {
        let ctg = this.coursetypegroups.find((i) => i.id == this.certificate.ctg_id)
        if (ctg) {
          if (ctg.coursetype_mandatory) {
            bool = true
          }
        }
      }

      return bool
    },
    computedTitleRequired() {
      let bool = false

      if (this.certificate.ctg_id) {
        let ctg = this.coursetypegroups.find((i) => i.id == this.certificate.ctg_id)
        if (ctg) {
          if (!ctg.coursetype_mandatory) {
            bool = true
          }
        }
      }

      return bool
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.view = this.$route.query.view

    this.from_module = this.$route.query.from_module
    this.from_id = this.$route.query.from_id

    let lists = [
      { key: "classes", module: "classes", query: "show_all=true" },
      { key: "coursetypegroups", module: "coursetypegroups", query: "show_all=true&show_hidden=1&sort_by=category&sort_order=asc" }
    ]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.classes = res.data.classes
      this.coursetypegroups = res.data.coursetypegroups

      if (!this.id) {
        this.page_title = this.$t("certificates.new_certificate")

        this.certificate = {
          //issued_date: this.moment().format(this.MYSQL_DATE_FORMAT),
        }

        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.certificate))

        // Set default student if creating of certificate is from Participant module
        if (this.from_module == "participants" && this.from_id) {
          this.certificate.participant_id = this.from_id
          this.getStudents("id", this.certificate.participant_id)
        }
      } else {
        this.title = this.$t("certificates.update_title")

        axios
          .get(this.API_URL + "certificate/" + this.id)
          .then((res) => {
            if (typeof res.data.errors !== "undefined") {
            } else {
              this.postData(res.data.data)
              this.courseTypeGroupChange()
              this.getStudents("id", this.certificate._participant_id)
              this.refresh_subpanels()
            }
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    postData(data) {
      data._participant_id = data.participant_id
      data.participant_id = null

      this.page_title = this.$t("certificates.edit_certificate", {
        //name: data.title, // display title before reverting it
      })

      data.title = data.original_title

      this.certificate = data
      this.moduletemplates = this.certificate.moduletemplates.filter((i) => i.add_to_expertise == 1)
      this.moduletemplates.forEach((item, index) => {
        item.moduleoptions = item.moduleoptions.filter((i) => i.add_to_expertise == 1)
        this.mtCollapsed[index] = true
      })

      this.predata = JSON.parse(JSON.stringify(this.certificate)) // JSON stringify and parse to remove variable reactiveness

      // format additional data
      this.additionalTitles = []
      if (this.certificate.title) {
        this.additionalTitles.push(this.certificate.title)
      }
      let titleArray = JSON.parse(this.certificate.additional_titles)
      if (titleArray && titleArray.length > 0) {
        titleArray.forEach((title) => {
          if (title) {
            this.additionalTitles.push(title)
          }
        })
      }

      this.selectedCourseTypes = this.certificate.coursetypes.map((a) => a.id)
    },
    refresh_subpanels() {
      this.dc_ids = this.certificate.documents.map((a) => a.id)
      this.dc_list()
    },
    dc_list() {
      this.dc_show_loading = true

      let ids = this.dc_ids.join(",")
      let { sortBy, descending, page, itemsPerPage } = this.dc_pagination
      let query = this.$queryString(this.dc_pagination, { certificate_id: this.certificate.id })

      if (this.certificate.id) {
        axios
          .get(this.API_URL + "certificate/documents" + "?" + query)
          .then((res) => {
            this.subpanel_documents = res.data.data
            this.dc_total = res.data.meta.total
            this.dc_refresh = false
            this.dc_show_loading = false

            this.dc_pagination.page = res.data.meta.current_page
            this.dc_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    downloadFile(id, filename) {
      axios({
        url: this.API_URL + "certificate/download",
        method: "POST",
        responseType: "arraybuffer",
        data: {
          id: id
        }
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", filename)
            link.click()
          }
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    uploadFiles() {
      let vm = this
      let formData = new FormData()

      formData.append("id", this.certificate.id)

      this.files.forEach((file, index) => {
        formData.append("files[" + index + "]", file)
      })

      axios
        .post(this.API_URL + "certificate/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res) => {
          let data = res.data.data
          this.dc_ids = data.documents.map((a) => a.id)

          vm.files = []
          vm.dc_list()
        })
        .catch((err) => console.log(err))
    },
    documentOnDrop(e) {
      this.document_dragover = false
      if (e.dataTransfer.files.length) {
        Array.from(e.dataTransfer.files).forEach((file) => {
          this.files.push(file)
        })
      }
    },
    deleteFile(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "certificate/delete/" + id)
            .then((res) => {
              let data = res.data.data
              this.dc_ids = data.documents.map((a) => a.id)

              vm.dc_list()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((error) => {
              console.log(error.response.data)
            })
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            // Handle combobox values
            let _participantId = null

            if (typeof this.certificate.participant_id == "object") {
              _participantId = this.certificate.participant_id.id
            }

            if (this.newTitle) {
              this.saveAddTitle()
            }

            // Format additional title
            let titlesArray = JSON.parse(JSON.stringify(this.additionalTitles))
            let additionalTitles = ""
            if (titlesArray.length > 0) {
              this.certificate.title = titlesArray[0]
              titlesArray.shift() // remove first title
              additionalTitles = JSON.stringify(titlesArray)
            }

            if (!this.certificate.id) {
              // Create
              axios
                .post(this.API_URL + "certificate", {
                  title: this.computedTitleRequired ? this.certificate.title : null,
                  additional_titles: this.computedTitleRequired ? additionalTitles : null,
                  description: this.certificate.description,
                  company_name: this.certificate.company_name,
                  valid_until: this.certificate.valid_until,
                  issued_date: this.certificate.issued_date,
                  issued_by: this.certificate.issued_by,
                  issued_by_vat: this.certificate.issued_by_vat,
                  course_name: this.certificate.course_name,
                  course_held_by: this.certificate.course_held_by,
                  class_id: this.certificate.class_id,
                  participant_id: _participantId,
                  ctg_id: this.certificate.ctg_id,
                  ctg_name: this.computedSelectedCourseTypeGroupName,
                  ctg_coursetype_mandatory: this.ctg_coursetype_mandatory,
                  coursetypes: this.selectedCourseTypes.join(","),
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.postData(res.data.data)
                      vm.updateParticipantId(this.certificate._participant_id)

                      if (vm.files.length > 0) {
                        vm.uploadFiles()
                      }

                      vm.courseTypeGroupChange()

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.from_id) {
                        vm.$router.push(this.BACKEND_URL + "/" + vm.from_module + "/edit/" + vm.from_id).catch()
                      } else {
                        vm.$router.replace(this.BACKEND_URL + `/certificates/edit/${vm.certificate.id}`).catch(() => {})
                        vm.refresh_subpanels()
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "certificate", {
                  id: this.certificate.id,
                  title: this.computedTitleRequired ? this.certificate.title : null,
                  additional_titles: this.computedTitleRequired ? additionalTitles : null,
                  description: this.certificate.description,
                  company_name: this.certificate.company_name,
                  valid_until: this.certificate.valid_until,
                  issued_date: this.certificate.issued_date,
                  issued_by: this.certificate.issued_by,
                  issued_by_vat: this.certificate.issued_by_vat,
                  course_name: this.certificate.course_name,
                  course_held_by: this.certificate.course_held_by,
                  class_id: this.certificate.class_id,
                  participant_id: _participantId,
                  ctg_id: this.certificate.ctg_id,
                  ctg_name: this.computedSelectedCourseTypeGroupName,
                  ctg_coursetype_mandatory: this.ctg_coursetype_mandatory,
                  coursetypes: this.selectedCourseTypes.join(",")
                })
                .then((res) => {
                  vm.postData(res.data.data)
                  vm.updateParticipantId(this.certificate._participant_id)

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.files.length > 0) {
                    vm.uploadFiles()
                  }

                  vm.refresh_subpanels()
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "certificate/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/certificates")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    getStudents(key, value) {
      axios
        .get(
          this.API_URL +
            `participants?resourcetype=user-ddlist&query_${key}=${value}&query_tenant_user_status=1sort_by=first_name&sort_order=asc`
        )
        .then((response) => {
          if (response.status == 200) {
            this.participants = response.data.data

            if (key == "id") {
              this.updateParticipantId(value)
            }
          }
        })
        .catch((err) => console.log(err))
    },
    updateParticipantId(id) {
      this.certificate.participant_id = this.participants.find((i) => i.id == id)
      this.predata = JSON.parse(JSON.stringify(this.certificate)) // JSON stringify and parse to remove variable reactiveness
    },

    openEditFile(file) {
      this.selectedFile = JSON.parse(JSON.stringify(file))
      this.showEditFileModal = true
    },
    updateFile() {
      let vm = this

      if (this.selectedFile) {
        axios
          .post(this.API_URL + "certificate/updatefile", {
            id: this.selectedFile.id,
            filename: this.selectedFile.original_filename,
            title: this.selectedFile.title
          })
          .then((res) => {
            if (res.data.status == "ok") {
              this.dc_refresh = true
            }

            vm.closeEditFile()
            vm.$awn.success(vm.$t("global.update_success"))
          })
          .catch((err) => console.log(err))
      } else {
        this.closeEditFile()
      }
    },
    closeEditFile() {
      this.selectedFile = {}
      this.showEditFileModal = false
    },
    courseTypeGroupChange() {
      let id = this.certificate.ctg_id
      let ctg = this.coursetypegroups.find((i) => i.id == id)
      if (ctg) {
        this.ctg_coursetype_mandatory = ctg.coursetype_mandatory

        if (ctg.available_to_all) {
          let lists = [
            {
              key: "coursetypes",
              module: "coursetypes",
              query: "show_all=true&show_hidden=1&query_coursetypegroup_id=" + ctg.id + "&sort_by=category&sort_order=asc"
            }
          ]

          axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
            this.coursetypes = res.data.coursetypes
          })
        } else {
          this.coursetypes = []
          this.selectedCourseTypes = []
        }
      }
    },
    openAddTitle() {
      this.showAddTitleModal = true
      setTimeout(() => {
        this.$refs.new_title.focus()
      })
    },
    saveAddTitle() {
      if (this.newTitle) {
        this.additionalTitles.push(this.newTitle)
        this.closeAddTitle()
      } else {
        this.$awn.alert(this.$t("certificates.new_title_required"))
      }
    },
    closeAddTitle() {
      this.newTitle = null
      this.showAddTitleModal = false
    },
    removeAdditionalTitle(index) {
      this.additionalTitles.splice(index, 1)
    },
    clpsExpndModules(idx) {
      let bool = !this.mtCollapsed[idx]
      this.$set(this.mtCollapsed, idx, bool)
    }
  }
}
</script>

<style>
.cert-title .v-select__selection {
  color: rgba(0, 0, 0, 0.87) !important;
}
.add-title-btn.v-btn:not(.v-btn--round).v-size--small {
  height: 25px !important;
}
.tbl-titles {
  margin-left: 6px;
  border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
